import React, { useState } from 'react';
import { DefaultImage } from './Image.styled';

type Props = Omit<
  React.ComponentProps<typeof DefaultImage>,
  'isLoaded' | 'isSelected'
>;

export const Image = (props: Props) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <DefaultImage
      isLoaded={isLoaded}
      onLoad={(e) => {
        props?.onLoad?.(e);
        setIsLoaded(true);
      }}
      {...props}
    />
  );
};
